import React from "react";
import {Field} from "redux-form/immutable";
import {Map} from "immutable";
import ActionButton from "../../../components/ActionButton";
import TextInputField from "../../../components/forms/TextInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";

function numerical(value) {
  const parsed = parseInt(value, 10);
  return isNaN(parsed) ? value : parsed;
}

// The lines of a purchase order, for a FieldArray: a product and a quantity
// each. `products` excludes water, which is never bought from a supplier.
const LinesField = ({fields, products}) => (
  <React.Fragment>
    {fields.map((member, index) => (
      <React.Fragment key={index}>
        <tr className="lineSeparator">
          <th>Line {index + 1}</th>
          <td><ActionButton label="Remove line" primary={false} onClick={() => fields.remove(index)} /></td>
        </tr>
        <Field label="Product" name={`${member}.sku`} component={DropDownInputField}
          data={products} valueKey="sku" titleKey="label" showBlank={true} />
        <Field label="Quantity" name={`${member}.quantity`} type="number" normalize={numerical} component={TextInputField} />
      </React.Fragment>
    ))}
    <tr>
      <td colSpan={2}>
        <ActionButton label="Add line" primary={false} onClick={() => fields.push(Map())} />
      </td>
    </tr>
  </React.Fragment>
);

// Products a supplier can deliver, labelled "SKU — title".
export function orderableProducts(products) {
  return products
    .filter((product) => !product.get("sku").startsWith("WAT-"))
    .map((product) => product.set("label", `${product.get("sku")} — ${product.get("title")}`));
}

// Lines the admin left without a product are dropped.
export function filledLines(lines) {
  return lines.filter((line) => line && line.get("sku"))
    .map((line) => Map({sku: line.get("sku"), quantity: line.get("quantity")}));
}

export default LinesField;
